<router-outlet />
<app-common-toast></app-common-toast>

<router-outlet></router-outlet>